import { Dtos, Relations } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useRequest } from "../../../utils/request";
import { adminActionItemsQueryKey, transformActionItems } from "../action-item.keys";

export const useFetchAdminActionItemsForRelation = (relation: Relations.ActionItems) => {
	const { get } = useRequest();

	const actionItemsRequest = useQuery({
		queryKey: adminActionItemsQueryKey.actionItemsByRelation(relation),
		queryFn: async () => {
			const data = await get<Dtos.ActionItem.Get.Response[]>(
				`/v2/action-items?relationType=${relation.relationType}&relationId=${relation.relationId}`,
			);
			return transformActionItems(data);
		},
	});

	return useMemo(() => {
		const kvActionItems = (() => {
			const actionItems = actionItemsRequest.data;
			if (actionItems !== undefined && actionItems !== null) {
				return actionItems;
			}
			return {};
		})();
		return {
			actionItems: kvActionItems,
			actionItemsIsLoading: actionItemsRequest.isLoading,
		};
	}, [actionItemsRequest, actionItemsRequest.data]);
};
